import { Component, OnInit, Input, Output,EventEmitter } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';

// Depending on whether rollup is used, moment needs to be imported differently.
// Since Moment.js doesn't have a default export, we normally need to import using the `* as`
// syntax. However, rollup creates a synthetic default module and we thus need to import it using
// the `default as` syntax.
import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import {defaultFormat as _rollupMoment} from 'moment';

const moment = _rollupMoment || _moment;

// See the Moment.js docs for the meaning of these formats:
// https://momentjs.com/docs/#/displaying/format/
export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM-DD',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY-MM-DD',
    dateA11yLabel: 'YYYY-MM-DD',
    monthYearA11yLabel: 'YYYY-MM-DD',
  },
};

@Component({
  selector: 'ark-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ]
})
export class FilterComponent implements OnInit {

  objectKeys = Object.keys;

  @Input() menu: any;
  @Input() type: string;
  @Input() selection: any;
  @Input() group: FormGroup;
  @Input() enableBtn: Boolean = true;
  @Output() onClick = new EventEmitter<any>();
  @Output() clear = new EventEmitter<any>();


  constructor() { }

  ngOnInit() {

  }

  onClickButton(event) {
    this.onClick.emit(event);
  }

  onEnbledBtn(e){
    var i = 0;
    Object.keys(this.group.controls).forEach(key => {
        if ( this.group.controls[key].value != '') {
          i++;
        }
    });
    if (i == 0) {
      this.enableBtn = true;
    } else {
      this.enableBtn = false;
    }
  }

  onClear(e) {
    this.clear.emit(event);
    this.enableBtn = true;
    return true;
  }
}

